import React, { useState, useEffect, useCallback } from 'react';
import classnames from 'classnames';
import { Table, Icons } from '@casanova/casanova-common';
import styles from './styles.module.css';
import { MASSIVE_CHANGE_TYPES } from './columns';

export default function StepTwo({
  initialTab,
  records,
  onDownloadRecords,
  massiveChangeType
}) {

  const columnsToUse = (tabActive = 1) => {
    return tabActive == 1 ? MASSIVE_CHANGE_TYPES[massiveChangeType] :
    MASSIVE_CHANGE_TYPES[`${massiveChangeType}_ERROR`];
  }

  const [tabActive, setTabActive] = useState(initialTab);
  useEffect(() => {
    setTabActive(initialTab);
  }, [initialTab]);

  const buttonFirst = classnames(styles.btn, styles.first, {
    [styles.active]: tabActive === 1,
  });
  const buttonClass = classnames(styles.btn, styles.second, {
    [styles.active]: tabActive === 2,
  });

  const handleDownloadFailed = useCallback(() => {
    if (records && records.failed_records && records.failed_records.length) {
      onDownloadRecords();
    }
  }, [records, onDownloadRecords]);

  return (
    <>
      <form>
        <div className={buttonFirst} onClick={() => setTabActive(1)}>
          <span>
            Registros correctos (
            {records && records.success_records
              ? records.success_records.length
              : 0}
            )
          </span>
        </div>
        <div className={buttonClass} onClick={() => setTabActive(2)}>
          <span>
            Registros con error (
            {records && records.failed_records
              ? records.failed_records.length
              : 0}
            )
          </span>
        </div>
      </form>
      <p className={styles.comment}>
        <span>
          <Icons.Comment />
        </span>
        Antes de continuar, revisa y corrige los errores en caso necesario.
      </p>
      <div className={styles.tableWrapper}>
        <Table
          dataList={
            tabActive === 1 ? records.success_records : records.failed_records
          }
          columns={columnsToUse(tabActive)}
          rowKey="id"
        />
      </div>
    </>
  );
}

StepTwo.defaultProps = {
  initialTab: 1,
};
